import { FormattedMessage } from 'react-intl';
import { ProgressBar } from '@ets/design-system';

import { useGetElementStatusListQuery } from '_common/services/api/elementStatusApi';
import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';

import ElementStatusTable from './ElementStatusTable';
import ElementHeading from './ElementHeading';

import styles from './ElementStatus.module.scss';

const ElementStatus = () => {
  const { isLoading } = useGetElementStatusListQuery();

  return (
    <div className={styles.elementStatusContainer}>
      <IntlErrorBoundary fallbackType="sectionHeading" mockProps={{ size: 'l', sticky: true }}>
        <ElementHeading />
      </IntlErrorBoundary>
      {isLoading ? (
        <div className={styles.loading}>
          <ProgressBar variant="primary-dark" size="m" testId="status-loading">
            <FormattedMessage id="LOADING_STATUS" />
          </ProgressBar>
        </div>
      ) : (
        <IntlErrorBoundary size="xl" style={{ margin: '10rem 0 0 0' }}>
          <ElementStatusTable />
        </IntlErrorBoundary>
      )}
    </div>
  );
};

export default ElementStatus;
